<template>
    <div class="authenticate"></div>
</template>

<script>
import firebase from 'firebase'

export default {
    name: 'AuthenticateUser',
    data() {
        return {
            feedback: null,
            authenticated: null,
        }
    },
    methods: {
        handleResetPassword(auth, actionCode, continueUrl, lang) {
            console.log('handleResetPassword ',auth, actionCode, continueUrl, lang)
            // Localize the UI to the selected language as determined by the lang
            // parameter.
            // var accountEmail;
            // Verify the password reset code is valid.
            auth.verifyPasswordResetCode(actionCode).then((email) => {
                // var accountEmail = email;

                // TODO: Show the reset screen with the user's email and ask the user for
                // the new password.
                this.$emit('authenticated', {auth: auth, actionCode: actionCode, email: email, code: 'reset-password', message: 'Your email is verifed. You may reset your password.'})

                // // Save the new password.
                // auth.confirmPasswordReset(actionCode, newPassword).then((resp) => {
                // // Password reset has been confirmed and new password updated.

                // // TODO: Display a link back to the app, or sign-in the user directly
                // // if the page belongs to the same domain as the app:
                // // auth.signInWithEmailAndPassword(accountEmail, newPassword);

                // // TODO: If a continue URL is available, display a button which on
                // // click redirects the user back to the app via continueUrl with
                // // additional state determined from that URL's parameters.
                // }).catch(function(error) {
                // // Error occurred during confirmation. The code might have expired or the
                // // password is too weak.
                // console.log('Error occurred during confirmation ', error)
                // });
            }).catch(function(error) {
                // Invalid or expired action code. Ask user to try to reset the password
                // again.
                console.log('Invalid or expired action code ', error)
            });
        },
        handleRecoverEmail(auth, actionCode) {
            // Localize the UI to the selected language as determined by the lang
            // parameter.
            var restoredEmail = null;
            // Confirm the action code is valid.
            auth.checkActionCode(actionCode).then(function(info) {
                // Get the restored email address.
                restoredEmail = info['data']['email'];

                // Revert to the old email.
                return auth.applyActionCode(actionCode);
            }).then(function() {
                // Account email reverted to restoredEmail

                // TODO: Display a confirmation message to the user.

                // You might also want to give the user the option to reset their password
                // in case the account was compromised:
                auth.sendPasswordResetEmail(restoredEmail).then(function() {
                // Password reset confirmation sent. Ask user to check their email.
                }).catch(function(error) {
                    console.log(error)
                // Error encountered while sending password reset code.
                });
            }).catch(function(error) {
                // Invalid code.
                console.log(error)
            });
        },
        handleVerifyEmail(auth, actionCode, continueUrl, lang) {
            console.log('handleVerifyEmail ', auth, actionCode, continueUrl, lang)
            // Localize the UI to the selected language as determined by the lang
            // parameter.
            // Try to apply the email verification code.
            auth.applyActionCode(actionCode).then(() => {
                // Email address has been verified.

                // TODO: Display a confirmation message to the user.
                // You could also provide the user with a link back to the app.

                // TODO: If a continue URL is available, display a button which on
                // click redirects the user back to the app via continueUrl with
                // additional state determined from that URL's parameters.
                this.$emit('authenticated', {code: 'email-verified', message: 'Congrats! Your email has been verified. You may now login.'})
                // this.authenticated = continueUrl
            }).catch(function(error) {
                // Code is invalid or expired. Ask the user to verify their email address
                // again.
                console.log('error ', error)
            });
        },
        signInWithToken(active, cid, token) {
            // console.log('signInWithToken called ', active, cid, token)
            this.$store.dispatch('UserData/signInWithCustomToken', { active, cid, token })
        }
    },
    created() {
        // console.log('active - ', this.$route.query.active)
        // this.feedback = 'Congrats! you have verified your email'
        
        // Get the action to complete.
        var mode = this.$route.query.mode
        // Get the one-time code from the query parameter.
        var actionCode = this.$route.query.oobCode
        // (Optional) Get the continue URL from the query parameter if available.
        var continueUrl = this.$route.query.continueUrl
        // (Optional) Get the language code if available.
        var lang = this.$route.query.lang || 'en';
        // (Optional) Get the sign in token
        var token = this.$route.query.token
        // (Optional) Get the sign in token email
        // var email = this.$route.query.email
        // (Optional) Get the active param
        var active = this.$route.query.active === 'yes' ? this.$route.query.active : 'false'
        // (Optional) Get the church pin param
        var cid = this.$route.query.cid

        var auth = firebase.auth();
        // Handle the user management action.
        switch (mode) {
            case 'resetPassword':
            // Display reset password handler and UI.
            this.handleResetPassword(auth, actionCode, continueUrl, lang);
            break;
            case 'recoverEmail':
            // Display email recovery handler and UI.
            this.handleRecoverEmail(auth, actionCode, lang);
            break;
            case 'verifyEmail':
            // Display email verification handler and UI.
            this.handleVerifyEmail(auth, actionCode, continueUrl, lang);
            break;
            case 'signIn':
            // Email-link sign-in is handled centrally in router.beforeEach.
            break;
            case 'signInWithToken':
            this.signInWithToken(active, cid, token);
            break; 
            default:
            // Error: invalid mode.
        }
    }
}
</script>

<style>
/* .authenticate .contentTitle {
    font-size: 12vw;
    font-family: 'Playfair Display', serif;
    color: rgba(0,0,0,.75);
    text-align: center;
}
.authenticate .contentTitle span {
    color: rgba(244, 67, 54, 0.75);
} */
@media screen and (max-width: 55em) {
    /* .authenticate .contentTitle {
        font-size: 20vw;
    } */
}
</style>
